import datapoints from '../datapoints';
import { createMailFolderTableQuery } from 'owa-mail-list-actions';
import { getFocusedFilterForTable, getSortByForTable, } from 'owa-mail-list-store';
import getSelectedTableView from 'owa-mail-list-store/lib/utils/getSelectedTableView';
import { loadTableViewFromTableQuery } from 'owa-mail-table-loading-actions';
import * as undoActions from 'owa-mail-undo';
import { action } from 'satcheljs/lib/legacy';
/**
 * Selects a filter on a current selected table view
 * @param viewFilter viewFilter to select
 * @param actionSource source of this action
 */
export default action('selectFilter', datapoints.selectFilter)(function selectFilter(viewFilter, actionSource) {
    var selectedTableView = getSelectedTableView();
    if (viewFilter == 'UserCategory') {
        throw new Error('ViewFilter should not be user category when select filter is called');
    }
    var tableQuery = createMailFolderTableQuery(selectedTableView.tableQuery.folderId, selectedTableView.tableQuery.listViewType, selectedTableView.tableQuery.scenarioType, getFocusedFilterForTable(selectedTableView), viewFilter, null /* categoryName */, // Categories and view filters ['All', 'Unread', 'To Me', 'Flagged'] cannot exist together as when a category folder is selected. The view filter needs to be set to UserCategory
    getSortByForTable(selectedTableView) // Retain the sort column when selecting filter
    );
    undoActions.clearLastUndoableAction();
    return loadTableViewFromTableQuery(tableQuery, null /* loadTableViewDatapoint */, actionSource);
});
//# sourceMappingURL=selectFilter.js.map